// removed by extract-text-webpack-plugin
module.exports = {"resultSection":"style__resultSection___FAe2A","resultSectionTitle":"style__resultSectionTitle___1-hIo","resultItem":"style__resultItem___2R3cN","resultItemRegion":"style__resultItemRegion___3ik-X","resultItemWrap":"style__resultItemWrap___2qY0Z","resultItemTitle":"style__resultItemTitle___2LHP_","resultItemTitleRegion":"style__resultItemTitleRegion___EyA9X","resultItemDescrip":"style__resultItemDescrip___BEml0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchFullscreen/Content/style.scss
// module id = 223
// module chunks = 0